export default __webpack_public_path__ + "static/media/burgerlogger.c4e59484.png";